import { useCallback } from 'react';

import { useAnalyticsUtilities } from '../hooks/useAnalyticsUtilities';
import META from './useTrackClickedTranscriptWord.meta';

export type UseTrackClickedTranscriptWordParams = {
  clip_id: string;
  word: string;
};

export const useTrackClickedTranscriptWord = () => {
  const { track } = useAnalyticsUtilities();

  const trackClickedTranscriptWord = useCallback(
    (params: UseTrackClickedTranscriptWordParams) => {
      track(META.name, params);
    },
    [track],
  );

  return { trackClickedTranscriptWord };
};
